export default __webpack_public_path__ + "static/media/FR_1.4a2e003c.png";